/* eslint-disable array-callback-return */
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState, useImperativeHandle, Fragment } from 'react';
import gstActions from "../../../../Admin/Setup/redux/actions";
import { useSelector } from "react-redux";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import {
    capitalizeFirstLetter, idNamingConversion, checkComponentPermission,
    includeGstSettings, getColumnWidth, currencyFormat, downloadTitle
} from '../../../../../helpers/utilities';
import { Space, Image, Dropdown, Menu, Modal } from "antd";
import { Button, Box, Tab, Typography } from "@mui/material";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { LineView, HeaderView, LinesList } from "./Blocks";
import actions from "../../redux/actions";
import businessActions from "../../../../Admin/Home/redux/actions";
import addressActions from "../../../../Admin/Address/redux/actions";
import productActions from "../../../../Product/Product/redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import unitActions from "../../../../Product/Setup/redux/actions";
import { emptyValidation, customEmailValidation, customNumberValidation } from "../../../../../helpers/validation";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { CustomModal } from "../../../../Shared/components/DeleteModal";
import { Link, NavLink } from "react-router-dom";
import Dots from "../../../../../assets/images/dots.png";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { quoteTemplateType } from '../../../../../config/constant';
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import SupplyOrderModal from "../../../../Shared/components/SupplyOrderModal";
import { useEventListener } from "../../../../../helpers/useEventListener";
import { gstCalculation } from "../../../../../helpers/utilities";
import SupplierProducts from "../PurchaseSelfBill/SupplierProducts";
import moment from 'moment';
import productSetupActions from "../../../../Product/Setup/redux/actions";


export const CustomForm = React.forwardRef((props, ref) => {
    const { businessDetails, parameterDetails } = useSelector(state => state.homeReducer);
    const { view, orderId, showDetails, type, clsx, history, dispatch, classes, roleManagement } = props;
    const childRef = useRef('');
    const formRef = useRef('');
    const { locationDetails } = useSelector(state => state.productSetupReducer);
    const { myProductdetails, productPrices } = useSelector(state => state.productProductReducer);
    const { unitMesurementdetails } = useSelector(state => state.productSetupReducer);
    const { areaDetails, pincodeDetails, stateDetails, countryDetails, cityDetails } = useSelector(state => state.addressReducer);
    const { createDetails, createError, createLoader, editDetails, editError, editLoader, createData, editData } = useSelector(state => state.crudReducer);
    const { supplierDetails } = useSelector(state => state.purchaseManagementReducer);
    const { partyGstdetails, productGstdetails, currencyDetails, mopDetails, hsnDetails, taxCodedetails, otherTaxesdetails, cashDiscountDetails } = useSelector(state => state.adminSetupReducer);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [confirm, setConfirm] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [form, setForm] = useState({
        deliveryDate: new Date(),
        validDate: new Date(),
        transactionDate: new Date(),
        roundOffMethod: '', roundOffAmount: 0
    });
    const [tempAddress, setTempAddress] = useState({});
    const [cancelModal, setCancelModal] = useState(false);
    const [open, setOpen] = useState(false);
    const [preview, setPreview] = useState(false);
    const [status, setStatus] = useState('CREATED');
    const [addressModal, setAddressModal] = useState(false);

    const [error, setError] = useState({});
    const [value, setValue] = useState("lineView");
    const [lines, setLines] = useState([]);
    const [productsVisible, setProductsVisible] = useState(false);

    const validDate = new Date(form?.deliveryDate);
    validDate.setDate(form?.deliveryDate?.getDate() + 30);

    const customObject = (details, id) => {
        let a = details && details.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    useEffect(() => {
        loadTasks();
        return () => {
            dispatch({ type: productActions.CLEAR_PRICE_START });
            dispatch({ type: addressActions.CLEAR_ADDRESS_DETAILS_START });
            dispatch({ type: actions.CLEAR_PURCHASE_MANAGEMENT_DETAILS_START });
        };
    }, []);


    const loadTasks = () => {
        if (type === 'create') {
            supplierApi();
        }
        locationApi();
        dispatch({ type: businessActions.BUSINESS_DETAILS_START });

        dispatch({
            type: addressActions.STATE_DETAILS_START, url: 'state', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: addressActions.COUNTRY_DETAILS_START, url: 'country', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.PARTYGST_DETAILS_START, url: 'partygst', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.TAXCODE_DETAILS_START, url: 'taxcode', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.OTHERTAXES_DETAILS_START, url: 'taxcode', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.CASHDISCOUNT_DETAILS_START, url: 'cashdiscount', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.PRODUCTGST_DETAILS_START, url: 'productgst', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.CURRENCY_DETAILS_START, url: 'currency', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.MOP_DETAILS_START, url: 'mop', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                order: 'id  desc'
            }
        });

    }

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }, { ["or"]: [{ transType: { eq: null } }, { transType: { eq: 'PURCHASE' } }] }] };
        let or = { ["or"]: [] };

        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }

        filter['and'].push(or);
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            setConfirm(false);
            setStatus(createData.OrderStatus);
            history.push(`/purchase/purchase-management/purchase-order/${createData.id}/view`, `${type}`);
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            //setCommonError(error);
            toast.dismiss();
            toast.error(error);
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            setConfirm(false);
            setCancelModal(false);
            setStatus(editData.OrderStatus);
            history.push(`/purchase/purchase-management/purchase-order/${editData.id}/view`, `${type}`);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            toast.error(text);
        }
        childRef?.current?.handleAdjustHeight();
    }, [editDetails, editError]);

    const supplierApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: actions.SUPPLIER_DETAILS_START, url: 'supplierProfile',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 100,
                skip: 0
            },
        });
    }

    const onCancel = (data) => {
        setCancelModal(true);
    }

    const changeSupplier = (value) => {
        if (value?.isHold) {
            setError({
                ...error,
                supplierId: 'Please release the Supplier from ON-HOLD to allow for transaction to be processed.'
            });
            setForm({
                deliveryDate: new Date(),
                validDate: new Date(),
                transactionDate: new Date(),
                billFormat: businessDetails?.businessDocumentTemplates[0]?.sales_quote_template || 'quote-GST',
                priceIncludesTax: value?.priceIncludesTax || false
            });
        } else {
            let gstSetting = includeGstSettings(value, businessDetails);
            setError({
                ...error,
                supplierId: false
            });
            if (businessDetails?.stateId) {
                changeStateApi(businessDetails?.stateId);
            }

            if (businessDetails?.pincodeId) {
                dispatch({
                    type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                        where: { ["and"]: [{ pincodeId: businessDetails?.pincodeId }] }
                    }
                });
            }

            let business = {
                name: businessDetails?.businessName,
                // phone: businessDetails?.mobile || '',
                // email: businessDetails?.email || '',
                areaId: businessDetails?.areaId || null,
                address1: businessDetails?.address || '',
                areaName: businessDetails?.area?.name || '',
                stateId: businessDetails?.stateId || '',
                state: businessDetails?.state || '',
                stateName: businessDetails?.state?.name || '',
                pincodeId: businessDetails?.pincodeId || '',
                pincode: businessDetails?.pincode || '',
                pincodeValue: businessDetails?.pincode?.code || '',
                cityId: businessDetails?.cityId || '',
                city: businessDetails?.city || '',
                cityName: businessDetails?.city?.name || '',
                countryId: businessDetails?.countryId || '',
                country: businessDetails?.country || '',
                countryName: businessDetails?.country?.name || '',
            };
            let datas = {
                supplier: value,
                // name: value?.name,
                supplierId: value?.id,
                inAppTransition: value.inAppStatus === 'ACCEPTED' ? value.inAppTransition : false,
                inAppStatus: value?.inAppStatus,
                phone: value?.mobile || '',
                email: value?.email || '',
                // areaId: value?.areaId || null,
                // address1: value?.address1 || '',
                // areaName: value?.area?.name || '',
                // stateId: value?.stateId || '',
                // state: value?.state || '',
                // stateName: value?.state?.name || '',
                partyGstId: value?.partyGstId || '',
                partyGst: value?.partyGst || '',
                partyGstName: value?.partyGst?.code || '',
                currencyId: value?.currencyId || '',
                currency: value?.currency || '',
                currencyName: value?.currency?.name || '',
                mopId: value?.mopId || 0,
                mop: value?.mop || '',
                mopName: value?.mop?.method || '',
                priceIncludesTax: value?.priceIncludesTax || false,
                // pincodeId: value?.pincodeId || '',
                // pincode: value?.pincode || '',
                // pincodeValue: value?.pincode?.code || '',
                // cityId: value?.cityId || '',
                // city: value?.city || '',
                // cityName: value?.city?.name || '',
                // countryId: value?.countryId || '',
                // country: value?.country || '',
                // countryName: value?.country?.name || '',
                includeGst: gstSetting.includeGst || false,
                includeDisabled: gstSetting.includeDisabled,
                billFormat: gstSetting.includeGst ? 'quote-GST' : 'quote-no_GST',
                cashDiscount: value?.cashDiscount || '',
                taxCode: value?.taxCode || '',
                cashDiscountId: value?.cashDiscountId || '',
                taxCodeId: value?.taxCodeId || '',
                tcsNameId: value?.tcsId || '',
                tcsName: value?.tcs || ''
            };
            setForm({ ...form, ...datas, ...business });
            setTempAddress({ ...datas, ...business });
        }
    }

    const hsnApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ hsnCode: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: gstActions.HSN_DETAILS_START, filter: {
                where: filter,
                order: 'hsnCode asc',
                limit: 500,
                skip: 0
            },
        });
    }

    const handleAllGstCalc = (element) => {
        let a = element;
        if (element.includeGst && element.productGstId) {
            let p = productGstdetails?.filter((el) => { return el.id === element.productGstId });
            let percentage = p[0].percentage;
            let details = {
                percentage: percentage,
                stateId: form?.stateId,
                lineAmount: element.amount,
                priceIncludesTax: form?.priceIncludesTax || false,
            };
            let gstCalc = gstCalculation({
                ...businessDetails,
                stateId: form?.supplier?.stateId
            }, details, form?.supplier);
            a = {
                ...element,
                igstPercentage: parseFloat(gstCalc?.igst || 0),
                cgstPercentage: parseFloat(gstCalc?.cgst || 0),
                sgstPercentage: parseFloat(gstCalc?.sgst || 0),
                cgst: parseFloat(gstCalc?.cgstAmount || 0),
                sgst: parseFloat(gstCalc?.sgstAmount || 0),
                igst: parseFloat(gstCalc?.igstAmount || 0),
            };
        }

        return a;
    }

    const handleWarningYes = () => {
        setModalVisible(false);
        setForm({
            ...form, includeGst: false
        });
        lines && lines.length > 0 && lines.map((element, i) => {
            let mLines = {
                ...element,
                includeGst: false,
                igstPercentage: 0,
                cgstPercentage: 0,
                sgstPercentage: 0,
                cgst: 0,
                sgst: 0,
                igst: 0,
                gstAmount: 0,
            };
            return lines.splice(i, 1, mLines);
        });
    }

    const handleIncludeGst = (value) => {
        if (!value) {
            setModalVisible(true);
        } else {
            setForm({
                ...form, includeGst: value
            });
            lines && lines.length > 0 && lines.map((element, i) => {
                let party = partyGstdetails && partyGstdetails.filter(function (el) { return el.id === form?.partyGstId });
                if (party.length >= 0) {
                    if (element.productGstId) {
                        let p = party[0].productGsts && party[0].productGsts.filter(function (el) { return el.id === element.productGstId });
                        if (p.length >= 0) {
                            let percentage = p[0].percentage;
                            let details = {
                                percentage: percentage,
                                stateId: form?.stateId,
                                lineAmount: element.amount,
                                priceIncludesTax: form?.priceIncludesTax || false,
                            };
                            let gstCalc = gstCalculation({
                                ...businessDetails,
                                stateId: form?.supplier?.stateId
                            }, details, form?.supplier);

                            let mLines = {
                                ...element,
                                includeGst: true,
                                igstPercentage: parseFloat(gstCalc?.igst || 0),
                                cgstPercentage: parseFloat(gstCalc?.cgst || 0),
                                sgstPercentage: parseFloat(gstCalc?.sgst || 0),
                                cgst: parseFloat(gstCalc?.cgstAmount || 0),
                                sgst: parseFloat(gstCalc?.sgstAmount || 0),
                                igst: parseFloat(gstCalc?.igstAmount || 0),
                                gstAmount: parseFloat(gstCalc.gAmount || 0),
                            };

                            return lines.splice(i, 1, mLines);
                        }
                    }
                }
            });
        }
    }

    const handleCommonSubmit = (status, callDispatch = true) => {
        childRef?.current?.handleAdjustHeight();
        let emailCheck = true;
        let incudeGstCode = true;
        let emptySupplier = emptyValidation('Supplier Name', form?.supplierId, 'dropDown');
        let emptyMobile = emptyValidation('Phone Number', form?.phone);
        let emptyEmail = customEmailValidation('Email', form?.email);
        if (form?.email !== null && form?.email !== '' && !emptyEmail.isValid) {
            emailCheck = false;
        }

        let emptyGstCode = emptyValidation('Party GST Code', form?.partyGstId, 'dropDown');
        let emptyStateCheck = emptyValidation('State', form?.stateId, 'dropDown');
        if ((form?.includeGst && !emptyGstCode.isValid) || (form?.includeGst && !emptyStateCheck.isValid)) {
            incudeGstCode = false
        }

        let emptyCurrency = emptyValidation('Currency', form?.currencyId, 'dropDown');

        let stateCheck = true;
        if (businessDetails?.taxType?.taxCode === 'COMP' && businessDetails?.stateId !== form?.stateId) {
            stateCheck = false;
        }

        //let dueDateCheck = moment(dueDate).isSameOrAfter(moment(invoiceDate));
        let deliveryDateCheck = moment(moment(form.deliveryDate).format('YYYY-MM-DD')).isSameOrAfter(moment(form.transactionDate).format('YYYY-MM-DD'));
        let validDateCheck = moment(moment(form.validDate).format('YYYY-MM-DD')).isSameOrAfter(moment(form.transactionDate).format('YYYY-MM-DD'));
        let emptyPincode = emptyValidation('Pincode', form?.pincodeId, 'dropDown');

        setError({});
        if (emptySupplier.isValid && deliveryDateCheck && validDateCheck && stateCheck && emptyCurrency.isValid && emptyStateCheck.isValid &&
            emptyMobile.isValid && emailCheck && incudeGstCode && emptyPincode.isValid) {
            let a = [];
            lines && lines?.length > 0 && lines?.map((element, i) => {
                return a.push({ ...element })
            });
            a?.length > 0 && a?.map((element, i) => {
                return a.splice(i, 1, { ...handleAllGstCalc(element), lineNumber: i + 1 });
            });
            form.purchaseOrderLineItems = a;
            let subForm = { ...form };
            if (subForm?.partyGst) {
                subForm.partyGstName = subForm?.partyGst?.name || '';
            }
            if (subForm?.currency) {
                subForm.currencyName = subForm?.currency?.name || '';
            }
            if (callDispatch) {
                delete subForm.includeDisabled; delete subForm.currency; delete subForm.area; delete subForm.city;
                delete subForm.state; delete subForm.country; delete subForm.currency; delete subForm.netAmount; delete subForm.totalDiscount;
                delete subForm.business; delete subForm.partyGst; delete subForm.mop; delete subForm.pincode; delete subForm.createdBy; delete subForm.gstin;
                delete subForm.cashDiscount; delete subForm.taxCode; delete subForm.tcsName;
                delete subForm.id; delete subForm.supplier; delete subForm.inAppStatus; delete subForm.totalInvoiceAmount; delete subForm.businessDocumentTemplates;
                subForm.isViaNotification = subForm?.isViaNotification || false;
                subForm.version = subForm?.version || 0;
                subForm.salesOrderId = subForm?.salesOrderId || '';
                subForm.reference = subForm?.reference || '';
                subForm.comments = subForm?.comments || '';
                let a = [];
                lines && lines?.length > 0 && lines?.map((element, i) => {
                    return a.push({ ...element })
                });
                a?.length > 0 && a?.map((element, i) => {
                    delete element.cgstAmount;
                    delete element.discountCalcAmount;
                    delete element.discountPercAmount; delete element.batchActivation;
                    delete element.igstAmount;
                    delete element.number;
                    delete element.changed;
                    delete element.productUnitId;
                    delete element.sgstAmount;
                    delete element.useMrp;
                    delete element.hsn;
                    delete element.unit;
                    delete element.product;
                    delete element.productGst;
                    delete element.productUnit; delete element.location;
                    delete element.universalProduct; delete element.stockUnit;
                    element.lineNumber = (i + 1);
                    element.available_quantity = element.quantity;
                    element.deliver_quantity = 0;
                    element.productGstId = element?.productGstId || undefined;
                    element.hsnId = element?.hsnId || undefined;
                    return a.splice(i, 1, { ...handleAllGstCalc(element) });
                });
                if (lines?.length === 0) {
                    subForm.invoiceAmount = 0;
                    subForm.gstAmount = 0;
                }
                subForm.purchaseOrderLineItems = a;
                subForm.areaId = subForm?.areaId || null;
                subForm.mopId = subForm?.mopId || null;
                subForm.areaName = subForm?.areaName || '';
                subForm.mopName = subForm?.mopName || '';
                subForm.isHold = subForm?.isHold || false;
                subForm.OrderStatus = status || null;
                form.OrderStatus = status || null;
                subForm.cashDiscountId = subForm?.cashDiscountId || 0;
                subForm.taxCodeId = subForm?.taxCodeId || 0;
                subForm.tcsNameId = subForm?.tcsNameId || 0;
                subForm.roundOffMethod = subForm?.roundOffMethod || null;
                subForm.roundOffAmount = parseFloat(subForm?.roundOffAmount || 0);
                dispatch({
                    type: form?.id ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                    url: 'v1/sales-order/purchase-orders',
                    title: 'Purchase Order',
                    id: form?.id,
                    details: subForm
                });
            } else {
                return subForm;
            }
        } else {
            if (!stateCheck) {
                toast.dismiss();
                toast.error('Please note you are in GST-Composite scheme and Sales Bill cannot be generated due to Customer billing address in different state.');
            }
            setError({
                supplierId: emptySupplier?.errors,
                phone: emptyMobile?.errors,
                currencyId: emptyCurrency?.errors,
                partyGstId: emptyGstCode?.errors,
                stateId: emptyStateCheck?.errors,
                pincodeId: emptyPincode?.errors,
                deliveryDate: !deliveryDateCheck ? 'Receipt Date should greater or equal to transaction date' : '',
                validDate: !validDateCheck ? 'Valid Date should greater or equal to Receipt date' : ''
            });
            let v = 'headerView';
            if (emptySupplier?.errors && emptyMobile?.errors) {
                v = 'lineView';
            }
            handleChange(v);
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        handleCommonSubmit(status);
    }

    const handleChange = (newValue) => {
        setValue(newValue);
        childRef?.current?.handleAdjustHeight();
    };

    const handleConfirmSubmit = (e) => {
        e.preventDefault();
        let data = handleCommonSubmit(form?.inAppTransition ? 'REQUESTED' : 'ACCEPTED', false);
        if (data) {
            setConfirm(true);
        }
    }

    const changeHandler = (e, name = '', relation = false) => {
        if (name !== '' && relation) {
            if (name === 'stateId') {
                changeState(e);
            } else if (name === 'countryId') {
                changeCountry(e);
            } else if (name === 'pincodeId') {
                changePincode(e);
            } else if (name === 'cityId') {
                setForm({
                    ...form,
                    "areaId": '',
                    "areaName": '',
                    "pincodeId": '',
                    "pincodeValue": '',
                    "cityName": e?.name,
                    "cityId": e?.id,
                    "city": e
                });
            } else if (name === 'currencyId') {
                setForm({
                    ...form,
                    [name]: e.id,
                    currencyName: e.name
                });
            } else if (name === 'areaId') {
                let datas = {
                    [name]: e.id,
                    areaName: e.name,
                    area: e
                };
                if (lines?.length > 0) {
                    setTempAddress({ ...tempAddress, ...datas });
                    setAddressModal(true);
                } else {
                    setForm({ ...form, ...datas });
                }
            } else if (name === 'mopId') {
                setForm({
                    ...form,
                    [name]: e.id,
                    mopName: e?.method
                });
            } else if (name === 'partyGstId') {
                setForm({
                    ...form,
                    [name]: e.id,
                    partyGstName: e?.code
                });
            } else if (name === 'cashDiscountId') {
                setForm({
                    ...form,
                    [name]: e.id,
                    cashDiscount: e
                });
            } else if (name === 'taxCodeId') {
                setForm({
                    ...form,
                    [name]: e.id,
                    taxCode: e
                });
            } else if (name === 'tcsNameId') {
                setForm({
                    ...form,
                    [name]: e.id,
                    tcsName: e
                });
            } else {
                setForm({
                    ...form,
                    [name]: e.id
                });
            }
            setError({
                ...error,
                [name]: false
            });
        } else if (name !== '') {
            if (name === 'roundOffMethod') {
                let value = 0;

                if (form?.totalInvoiceAmount && e !== '') {
                    if (e === 'UP') {
                        value = Math.ceil(form?.totalInvoiceAmount || 0);
                    } else {
                        value = Math.floor(form?.totalInvoiceAmount || 0);
                    }
                }
                setForm({
                    ...form,
                    [name]: e,
                    'roundOffAmount': value ? parseFloat(parseFloat(value - form?.totalInvoiceAmount).toFixed(2)) : 0,
                    'invoiceAmount': value ? parseFloat(parseFloat(value).toFixed(2)) : form?.totalInvoiceAmount
                });
            } else {
                setForm({
                    ...form,
                    [name]: e
                });
            }
            setError({
                ...error,
                [name]: false
            });
        } else {
            if (e.target.name === 'address1') {
                setTempAddress({ ...tempAddress, [e.target.name]: e.target.value });
            }
            if (e.target.name === 'roundOffAmount') {
                setForm({
                    ...form,
                    [e.target.name]: e.target.value,
                    'invoiceAmount': parseFloat(parseFloat(form?.totalInvoiceAmount + parseFloat(e?.target?.value || 0)).toFixed(2))
                });
            } else {
                setForm({
                    ...form,
                    [e.target.name]: e.target.value
                });
            }
            setError({
                ...error,
                [e.target.name]: false
            });
        }
    }


    const changePincode = (value) => {
        let datas = {
            "areaId": '',
            "areaName": '',
            "pincodeId": value?.id,
            "pincode": value,
            "pincodeValue": value?.code || '',
            "cityId": value?.cityId || '',
            "city": value?.city || '',
            "cityName": value?.city?.name || '',
        };

        if (lines?.length > 0) {
            setTempAddress({ ...tempAddress, ...datas });
            setAddressModal(true);
        } else {
            setForm({ ...form, ...datas });
        }
        dispatch({
            type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                where: { ["and"]: [{ pincodeId: value?.id }] }
            }
        });
    }

    useImperativeHandle(ref, () => ({
        onEdit(data) {
            let gstSetting = includeGstSettings(data?.supplier, data?.business);
            setForm({
                ...data,
                priceIncludesTax: data?.priceIncludesTax || false,
                validDate: data?.validDate ? dayjs(data?.validDate).$d : null,
                deliveryDate: data?.deliveryDate ? dayjs(data?.deliveryDate).$d : null,
                transactionDate: data?.transactionDate ? dayjs(data?.transactionDate).$d : null,
                includeDisabled: gstSetting.includeDisabled,
                inAppStatus: data?.supplier?.inAppStatus,
                roundOffMethod: data?.roundOffMethod || '',
                totalInvoiceAmount: parseFloat(data?.invoiceAmount || 0) - parseFloat(data?.roundOffAmount || 0)
            });
            setTempAddress({
                ...data,
                validDate: data?.validDate ? dayjs(data?.validDate).$d : null,
                deliveryDate: data?.deliveryDate ? dayjs(data?.deliveryDate).$d : null,
                transactionDate: data?.transactionDate ? dayjs(data?.transactionDate).$d : null,
            });
            supplierApi('', data?.supplierId);
            setStatus(data?.OrderStatus);
            if (data?.stateId) {
                changeStateApi(data?.stateId);
            }

            if (data?.purchaseOrderLineItems) {
                setLines(data?.purchaseOrderLineItems);
            }

            if (data?.pincodeId) {
                dispatch({
                    type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                        where: { ["and"]: [{ pincodeId: data.pincodeId }] }
                    }
                });
            }
        },
        reSize() {
            childRef?.current?.handleAdjustHeight();
        }
    }));

    useEffect(() => {
        calculateGrandTotal(lines, false, form);
    }, [lines, form?.cashDiscountId, form?.taxCodeId, form?.tcsNameId]);

    useEffect(() => {
        if (businessDetails && businessDetails?.businessId && !orderId) {
            setForm({
                ...form,
                billFormat: businessDetails?.businessDocumentTemplates[0]?.sales_quote_template || 'quote-GST'
            })
        }
    }, [businessDetails]);


    const calculateGrandTotal = (lines, factBox = false, form) => {
        let data = {};
        if (lines && lines.length > 0) {
            let total = lines && lines.reduce((a, v) => a = a + v.amount, 0);
            let discount = lines && lines.reduce((a, v) => a = parseFloat(a) + parseFloat(v.discountAmount), 0);
            let discountPercent = lines && lines.reduce((a, v) => {
                if (v.amount < 0) {
                    a = parseFloat(a) - parseFloat(((v.quantity * v.pricePerUnit) * v.discountPercent) / 100)
                } else {
                    a = parseFloat(a) + parseFloat(((v.quantity * v.pricePerUnit) * v.discountPercent) / 100)
                }
                return a;
            }, 0);
            let gst = lines && lines.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0);

            let excisesAmount = lines && lines.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.excisesTotal || 0), 0);
            let disAmount = 0;
            if (form?.cashDiscountId) {
                disAmount = (total * (form?.cashDiscount?.percentage || 0)) / 100;
            }

            let assessableAmount = parseFloat(total || 0) - parseFloat(disAmount || 0) + parseFloat(excisesAmount || 0);
            if (form?.priceIncludesTax) {
                assessableAmount = parseFloat(assessableAmount || 0) - parseFloat(gst || 0);
            }

            let taxValue = 0;
            if (form?.taxCodeId) {
                taxValue = ((assessableAmount || 0) * (form?.taxCode?.percentage || 0)) / 100;
            }

            let tcsValue = 0;
            let tcsAmount = parseFloat(assessableAmount || 0) + parseFloat(taxValue || 0);
            if (form?.supplier?.tcsBoolean) {
                if (form?.tcsNameId) {
                    tcsValue = (tcsAmount * (form?.tcsName?.percentage || 0)) / 100;
                }
            }

            total = parseFloat(assessableAmount || 0) + parseFloat(taxValue || 0) + parseFloat(tcsValue || 0);

            data['invoiceAmount'] = total + gst + form?.roundOffAmount;
            data['totalInvoiceAmount'] = total + gst;
            data['netAmount'] = assessableAmount;
            data['assessableValue'] = assessableAmount;
            data['excisesAmount'] = excisesAmount;
            data['cashDiscountAmount'] = disAmount;
            data['tax'] = taxValue;
            data['tcs'] = tcsValue;
            data['totalDiscount'] = discount + discountPercent;
            data['gstAmount'] = gst;
            // if (form?.priceIncludesTax) {
            //     data['invoiceAmount'] = total + form?.roundOffAmount;
            //     data['totalInvoiceAmount'] = total;
            //     data['netAmount'] = total - gst;
            // } else {
            //     data['invoiceAmount'] = total + gst + form?.roundOffAmount;
            //     data['totalInvoiceAmount'] = total + gst;
            //     data['netAmount'] = total;
            // }
        } else {
            data['invoiceAmount'] = 0;
            data['totalInvoiceAmount'] = 0;
            data['totalDiscount'] = parseFloat(0.00);
            data['assessableValue'] = parseFloat(0.00);
            data['gstAmount'] = parseFloat(0.00);
            data['netAmount'] = parseFloat(0.00);
            data['excisesAmount'] = parseFloat(0.00);
            data['cashDiscountAmount'] = parseFloat(0.00);
            data['tax'] = parseFloat(0.00);
            data['tcs'] = parseFloat(0.00);
        }

        setForm({
            ...form, ...data
        });
    }

    const deleteLine = (id, lineId = '') => {
        let index = lines.findIndex((d, i) => id === i);
        if (index >= 0) {
            lines.splice(index, 1);
            setLines([...lines]);
            if (lineId) {
                dispatch({
                    type: crudActions.DELETE_DETAILS_START,
                    url: 'v1/sales-order/purchase-order-line-items',
                    title: 'Sales Orders Lines',
                    id: lineId
                });
            }
        }
    }

    const changeCountry = (value) => {
        let datas = {
            "areaId": "",
            "areaName": '',
            "pincodeId": "",
            "pincodeValue": '',
            "cityId": "",
            "cityName": '',
            "stateId": "",
            "stateName": '',
            "countryId": value?.id,
            "countryName": value?.name || '',
            "country": value,
            "currencyId": value.currencyId || ''
        };
        setForm({ ...form, ...datas });
        setTempAddress({ ...tempAddress, ...datas });
    }

    const changeState = (value) => {
        let datas = {
            "areaId": '',
            "areaName": '',
            "pincodeId": '',
            "pincodeValue": '',
            "cityId": '',
            "cityName": '',
            "stateId": value.id,
            "state": value,
            "stateName": value?.name || '',
            "countryId": value?.countryId || '',
            "country": value?.country || '',
            "countryName": value?.country?.name || '',
            "currencyId": value?.country?.currencyId || '',
        };
        setForm({ ...form, ...datas });
        setTempAddress({ ...tempAddress, ...datas });
        changeStateApi(value?.id);
    }


    const changeStateApi = (value) => {
        dispatch({
            type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
        dispatch({
            type: addressActions.CITY_DETAILS_START, url: 'city', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
    }

    // const lineSubmit = (data, lineId = '') => {
    //     data.changed = true;
    //     if (lineId !== '') {
    //         let index = lines.findIndex((d, i) => lineId === i);
    //         if (index >= 0) {
    //             lines.splice(index, 1, data);
    //         }
    //     } else {
    //         setLines((prevState) => {
    //             return [...prevState, data];
    //         });
    //     }
    // }

    const lineSubmit = (data, lineId = '') => {
        data.changed = true;
        if (lineId !== '') {
            setLines(prev =>
                prev.map((line, i) =>
                    i === lineId ? data : line
                )
            );
        } else {
            setLines(prev => [...prev, data]);
        }
    };

    const handlePreview = () => {
        if (lines && lines?.length > 0) {
            let data = handleCommonSubmit('CREATED', false);
            if (data) {
                setPreview(true);
                setOpen(true);
            }
        } else {
            toast.dismiss();
            toast.error('Please select line to preview document');
        }
    }

    const handleModalClose = (o) => {
        setOpen(o); setPreview(o);
    };

    const handleAddressUpdate = () => {
        setForm({
            ...form, ...tempAddress
        });
        setAddressModal(false);
        lines?.length > 0 && lines?.map((element, i) => {
            element.state = tempAddress?.stateName;
            element.area = tempAddress?.areaName;
            element.country = tempAddress?.countryName;
            element.city = tempAddress?.cityName;
            element.pincode = tempAddress?.pincodeValue;
            element.address = tempAddress?.address1;
            return lines.splice(i, 1, { ...element });
        });
    }

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 83) { // ALT + S
            e.preventDefault();
            if ((status === 'CREATED' || status === 'REJECTED') &&
                e.altKey && e.keyCode === 83) {
                if (formRef?.current?.getVisible()) {
                    formRef?.current?.handleLineSubmit(e);
                } else if (confirm) {
                    handleCommonSubmit(form?.inAppTransition ? 'REQUESTED' : 'ACCEPTED');
                } else {
                    handleSubmit(e);
                }
            }
        } else if (e.altKey && e.keyCode === 79) { // ALT + O
            e.preventDefault();
            if (status === 'CREATED') {
                if (lines && lines?.length === 0) {
                    toast.dismiss();
                    toast.error('If you want confirm, Please add lines and then confirm it...');
                } else if (confirm) {
                    handleCommonSubmit(form?.inAppTransition ? 'REQUESTED' : 'ACCEPTED');
                } else {
                    handleConfirmSubmit(e);
                }
            }
        } else if (e.altKey && e.keyCode === 69) { // ALT + E
            e.preventDefault();
            if ((status === 'CREATED' || status === 'REJECTED') && type === 'view') {
                history.push(`/purchase/purchase-management/purchase-order/${orderId}/edit`);
            }
        } else if (e.altKey && e.keyCode === 82) { // ALT + R
            e.preventDefault();
            if ((type === 'view' || type === 'edit') && status === 'REJECTED') {
                handleCommonSubmit('RESUBMITTED');
            }
        }
    };


    const locationApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };

        if (search) {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
        }

        if (id) {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: productSetupActions.LOCATION_DETAILS_START, url: 'locations',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    useEventListener("keydown", handleKeyDown);


    const handleBulkLineSubmit = (selected) => {
        selected?.length > 0 && selected?.map((element, i) => {
            element.address = form?.address1 || '';
            element.area = form?.areaName || '';
            element.state = form?.stateName || '';
            element.city = form?.cityName || '';
            element.country = form?.countryName || '';
            element.pincode = form?.pincodeValue || '';
            return selected.splice(i, 1, { ...element });
        });
        setLines(selected);
        setProductsVisible(false);
    }


    return (
        <Fragment>
            <CustomAccordion
                title={`${capitalizeFirstLetter(type)} Order`}
                top={"0"}
                topVisible={"50px"}
                zIndex={9}
                showDetails={showDetails}
                index={0}
                ref={childRef}
                component={
                    <Box
                        className={clsx(classes.removeUnderline, classes.positionRelative)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => handleSubmit(e)}>
                        {
                            showDetails ? <div className={classes.textAlignCenter}>
                                <div className={classes.loadMoreCircle}></div>
                            </div> : <>
                                <div className={classes.tabWrapSubmit}>
                                    <Space size={[20, 20]} direction="horizontal" align="center">
                                        {
                                            roleManagement !== '' && checkComponentPermission('Purchase Order', 'Page', 'Share Document') &&
                                            <div className={classes.templateView} >
                                                <NavLink to="#" tabIndex={-1} onClick={() => handlePreview()}>
                                                    <Image tabIndex={-1} className={""} src={ViewIcon} preview={false} />
                                                    <span className={classes.customerInvoiceNone}>View Order</span>
                                                </NavLink>
                                                {
                                                    (status === 'CREATED' || status === 'REJECTED' || (!form?.inAppTransition && status === 'REQUESTED')) &&
                                                    <AutoCompleteComponent
                                                        name={""}
                                                        id={idNamingConversion('billFormat', 'supplyOrder', 'DropDown')}
                                                        heads={[{ 'key': 'label', 'name': 'Name' }]}
                                                        details={quoteTemplateType}
                                                        parentValue={customObject(quoteTemplateType, form?.billFormat)}
                                                        onChange={(data) => { changeHandler(data.id, 'billFormat'); }}
                                                        position={'bottom'}
                                                        disabled={form?.includeGst}
                                                        customClasses={clsx(classes.customAutocomplete, classes.customerInvoice)}
                                                    />
                                                }
                                            </div>
                                        }
                                        {
                                            roleManagement !== '' && checkComponentPermission('Purchase Order', 'Page', 'Confirm') && status === 'CREATED' &&
                                            <Button
                                                tabIndex={-1}
                                                key="confirm"
                                                color="primary"
                                                variant="contained"
                                                onClick={(e) => handleConfirmSubmit(e)}
                                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader || createLoader }, { [classes.disabled]: lines.length === 0 })}>
                                                {
                                                    form?.inAppTransition ? 'Request' : 'Confirm'
                                                }
                                            </Button>
                                        }
                                        {
                                            (status === 'CREATED' || status === 'REJECTED' || (!form?.inAppTransition && status === 'REQUESTED')) && <>
                                                {
                                                    (type === 'edit' || type === 'create') ? <Button
                                                        tabIndex={-1}
                                                        key="Save"
                                                        type="submit"
                                                        color="primary"
                                                        variant="contained"
                                                        className={clsx(classes.modalBtn, { [classes.loading]: editLoader || createLoader })}>{type === 'create' ? 'Save' : 'Update'}</Button> : <Link
                                                            to={`/purchase/purchase-management/purchase-order/${orderId}/edit`}
                                                            className={clsx(classes.AddMoreBtn, classes.bold, classes.marginRight0, { [classes.loadingA]: editLoader || createLoader })}>Edit</Link>
                                                }
                                            </>
                                        }
                                        {
                                            roleManagement !== '' && checkComponentPermission('Purchase Order', 'Page', 'Re-Submit') &&
                                            (status === 'REJECTED') &&
                                            <Button
                                                tabIndex={-1}
                                                key="re-submit"
                                                color="primary"
                                                variant="contained"
                                                onClick={() => handleCommonSubmit('RESUBMITTED')}
                                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader || createLoader },
                                                    { [classes.disabled]: lines.length === 0 })}
                                            >Re-Submit</Button>
                                        }
                                        {
                                            ((status === 'ACCEPTED' || (!form?.inAppTransition && status === 'REQUESTED') || status === 'REJECTED') && !form?.isHold) &&
                                            <Dropdown
                                                trigger={['click']}
                                                placement={'bottomRight'}
                                                overlay={
                                                    <Menu className={clsx(classes.groupMenu)}>
                                                        <Menu.Item key={"Arrow"}></Menu.Item>
                                                        {
                                                            roleManagement !== '' && checkComponentPermission('Purchase Order', 'Page', 'Re-Submit') &&
                                                            form?.inAppTransition && (status === 'REJECTED' || status === 'RECEIVED') &&
                                                            <Menu.Item key={"Re-Submit"}><NavLink to={'#'}
                                                                onClick={() => handleCommonSubmit('RESUBMITTED')}>Re-Submit</NavLink></Menu.Item>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkComponentPermission('Purchase Order', 'Page', 'Cancel') &&
                                                            form?.inAppTransition && status === 'REJECTED' &&
                                                            <Menu.Item key={"Cancel"}><NavLink to={'#'}
                                                                onClick={() => onCancel()}>Cancel</NavLink></Menu.Item>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkComponentPermission('Purchase Order', 'Page', 'Cancel') &&
                                                            status === 'ACCEPTED' &&
                                                            <Menu.Item key={"Cancel"}><NavLink to={'#'}
                                                                onClick={() => onCancel()}>Cancel</NavLink></Menu.Item>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkComponentPermission('Purchase Order', 'Page', 'Receipt') &&
                                                            status === 'ACCEPTED' &&
                                                            <Menu.Item key={"Create Goods Receipt"}><NavLink to={`/purchase/purchase-management/purchase-order/${orderId}/goods-receipt`}>Create Goods Receipt</NavLink></Menu.Item>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkComponentPermission('Purchase Order', 'Page', 'Invoice') &&
                                                            status === 'ACCEPTED' &&
                                                            <Menu.Item key={"Create Invoice"}><NavLink to={`/purchase/purchase-management/purchase-order/${orderId}/invoice`}>Create Invoice</NavLink></Menu.Item>
                                                        }
                                                        {/* {
                                                            roleManagement !== '' && checkComponentPermission('Purchase Order', 'Page', 'Order Accepted') &&
                                                            !form?.inAppTransition && status === 'REQUESTED' &&
                                                            <Menu.Item key={"Order Accepted"}><NavLink to={'#'}
                                                                onClick={() => handleCommonSubmit('ACCEPTED')}>Order Accept</NavLink></Menu.Item>
                                                        } */}
                                                    </Menu>
                                                }>
                                                <Image
                                                    width={22}
                                                    src={Dots}
                                                    preview={false}
                                                />
                                            </Dropdown>
                                        }

                                    </Space>
                                </div>
                                <div className={classes.tabDesign}>
                                    <TabContext value={value}>
                                        <TabList onChange={(event, newValue) => handleChange(newValue)}>
                                            <Tab className={classes.Bordertab_1} label="Line View" value={"lineView"} />
                                            <Tab className={classes.Bordertab_2} label="Header View" value={"headerView"} />
                                        </TabList>
                                        <TabPanel value={"lineView"}>
                                            <LineView {...props}
                                                form={form}
                                                error={error}
                                                status={status}
                                                view={view}
                                                currencyFormat={(amount) => currencyFormat(amount)}
                                                supplierApi={(search = '', id = '') => supplierApi(search, id)}
                                                idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                                customObject={(details, id) => customObject(details, id)}
                                                changeSupplier={(data) => changeSupplier(data)}
                                                supplierDetails={supplierDetails}
                                                capitalizeFirstLetter={(v) => capitalizeFirstLetter(v)}
                                                changeHandler={(e, name = '', relation = false) => changeHandler(e, name, relation)}
                                                cashDiscountDetails={cashDiscountDetails}
                                                taxCodedetails={taxCodedetails}
                                                otherTaxesdetails={otherTaxesdetails}
                                                parameterDetails={parameterDetails}
                                                lines={lines}
                                            />
                                        </TabPanel>
                                        <TabPanel value={"headerView"}>
                                            <HeaderView {...props}
                                                handleIncludeGst={(v) => handleIncludeGst(v)}
                                                form={form}
                                                view={view}
                                                error={error}
                                                status={status}
                                                currencyFormat={(amount) => currencyFormat(amount)}
                                                mopDetails={mopDetails}
                                                currencyDetails={currencyDetails}
                                                partyGstdetails={partyGstdetails}
                                                stateDetails={stateDetails}
                                                areaDetails={areaDetails}
                                                cityDetails={cityDetails}
                                                pincodeDetails={pincodeDetails}
                                                countryDetails={countryDetails}
                                                capitalizeFirstLetter={(v) => capitalizeFirstLetter(v)}
                                                supplierApi={(search = '', id = '') => supplierApi(search, id)}
                                                idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                                customObject={(details, id) => customObject(details, id)}
                                                changeSupplier={(data) => changeSupplier(data)}
                                                supplierDetails={supplierDetails}
                                                changeHandler={(e, name = '', relation = false) => changeHandler(e, name, relation)}
                                                validDate={validDate}
                                                cashDiscountDetails={cashDiscountDetails}
                                                taxCodedetails={taxCodedetails}
                                                otherTaxesdetails={otherTaxesdetails}
                                                parameterDetails={parameterDetails}
                                                lines={lines}
                                            />
                                        </TabPanel>
                                    </TabContext>
                                </div>
                            </>
                        }
                    </Box>
                }
            />
            <CustomAccordion
                title={'Purchase Order Lines'}
                top={"49"}
                topVisible={"150px"}
                zIndex={7}
                showDetails={showDetails}
                index={1}
                ref={childRef}
                component={
                    <>
                        {
                            showDetails ? <div className={classes.textAlignCenter}>
                                <div className={classes.loadMoreCircle}></div>
                            </div> : <LinesList
                                classes={classes}
                                form={form}
                                type={type}
                                useEventListener={useEventListener}
                                ref={formRef}
                                idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                currencyFormat={(amount) => currencyFormat(amount)}
                                clsx={clsx}
                                lines={lines}
                                dispatch={dispatch}
                                customObject={(details, id) => customObject(details, id)}
                                hsnApi={(s = '', id = '') => hsnApi(s, id)}
                                productApi={(s = '', id = '') => productApi(s, id)}
                                productActions={productActions}
                                productPrices={productPrices}
                                myProductdetails={myProductdetails}
                                partyGstdetails={partyGstdetails}
                                businessDetails={businessDetails}
                                unitMesurementdetails={unitMesurementdetails}
                                getColumnWidth={(head, v) => getColumnWidth(head, v)}
                                productGstdetails={productGstdetails}
                                hsnDetails={hsnDetails}
                                deleteLine={(id, lineId = '') => deleteLine(id, lineId)}
                                lineSubmit={(data, id) => lineSubmit(data, id)}
                                headerView={view}
                                locationApi={() => locationApi()}
                                handleAddProducts={() => setProductsVisible(true)}
                                roleManagement={roleManagement}
                                locationDetails={locationDetails}
                                checkComponentPermission={(v, page, d) => checkComponentPermission(v, page, d)}
                                parameterDetails={parameterDetails}
                            />
                        }
                    </>
                }
            />
            <CustomModal
                visible={confirm}
                yesButton={'Yes'}
                noButton={'No'}
                title={'Order Confirmation'}
                loading={createLoader || editLoader}
                onOpen={() => handleCommonSubmit(form?.inAppTransition ? 'REQUESTED' : 'ACCEPTED')}
                onClose={() => setConfirm(false)}
                text={< p > Are you sure do you want to Confirm the Order ?</p >}
            />
            {
                open &&
                <SupplyOrderModal open={open}
                    title={downloadTitle(preview ? form : type === 'create' ? createData : editData, 'supply-order')}
                    handleClose={(o) => handleModalClose(o)}
                    link={preview ? '' : `/purchase/purchase-management/purchase-order/${orderId || createData.id}/view`}
                    {...props}
                    type={"create"}
                    businessDetails={businessDetails}
                    proformaPreview={status === 'CREATED' ? true : false}
                    details={preview ? form : type === 'create' ? createData : editData} />
            }
            <CustomModal
                onClose={(v) => setCancelModal(v)}
                yesButton={'Yes'}
                noButton={'No'}
                title={'Cancel Confirmation'}
                loading={editLoader}
                visible={cancelModal}
                onOpen={() => handleCommonSubmit('CANCELLED')}
                text={<p>Are you sure you want to <span className={classes.deleteRed}> Cancel </span> {form?.serialNo} ?</p>}
            />
            <CustomModal
                onClose={(v) => setAddressModal(v)}
                yesButton={'Yes'}
                noButton={'No'}
                title={`Address change`}
                visible={addressModal}
                onOpen={() => handleAddressUpdate()}
                text={<p>Address change in header will update the “address” in the order lines, do you want to continue to update the address?</p>}
            />
            {
                productsVisible && <SupplierProducts
                    classes={classes}
                    clsx={clsx}
                    productGstdetails={productGstdetails}
                    dispatch={dispatch}
                    handleClose={() => setProductsVisible(false)}
                    visible={productsVisible}
                    supplierId={form?.supplierId}
                    includeGst={form?.includeGst}
                    productActions={productActions}
                    businessDetails={businessDetails}
                    supplierDetail={form?.supplier}
                    productPrices={productPrices}
                    hsnApi={(s = '', id = '') => hsnApi(s, id)}
                    lineSubmit={(selected) => handleBulkLineSubmit(selected)}
                    lines={lines}
                    priceIncludesTax={form?.priceIncludesTax || false}
                    order={true}
                    viewType={'myProducts'}
                    creditNote={false}
                    locationApi={() => locationApi()}
                    hsnDetails={hsnDetails}
                    locationDetails={locationDetails}
                    unitMesurementdetails={unitMesurementdetails}
                    customObject={(details, id) => customObject(details, id)}
                    emptyValidation={(name, id, type = '') => emptyValidation(name, id, type)}
                    gstCalculation={(business, details, supplier) => gstCalculation(business, details, supplier)}
                    customNumberValidation={(name, value) => customNumberValidation(name, value)}
                    purchase={true}
                />
            }
            <Modal
                title={'Warning message'}
                open={modalVisible}
                onOk={() => setModalVisible(false)}
                onCancel={() => setModalVisible(false)}
                footer={[
                    <Space direction="horizontal" align="center" >
                        <NavLink
                            to={`#`} onClick={() => handleWarningYes()}
                            className={clsx(classes.AddMoreBtn, classes.bold, classes.textAlignLeft)}
                        >Yes</NavLink>
                        <NavLink
                            to={`#`} onClick={() => setModalVisible(false)}
                            className={clsx(classes.modalBtn, classes.bold, classes.textAlignLeft)}
                        >No</NavLink>
                    </Space>
                ]}
                className={clsx(classes.commonPopup, classes.commonPopupText, classes.removeUnderline, classes.deletePopup)}>
                <Typography variant={'subtitle1'} className={clsx(classes.fonSize14, classes.textAlignLeft)} style={{ color: "#1c314c" }}>
                    {
                        !form?.includeGst ? 'Please note, changing the Tax Invoice to "Yes" should comply to GST law. Are you sure you want to continue to make this change ?'
                            : 'Please note, changing the Tax Invoice to "No" should comply to GST law. Are you sure you want to continue to make this change ?'
                    }
                </Typography>
            </Modal>
        </Fragment>
    )
})